import React, { useEffect } from 'react';
import { getHostPortalLoginUrl } from '../../utils/hostPortalLogin.utils';
import { LoadingSpinner } from '../Loading/LoadingSpinner';
import {
  LOADING_FORM_ARIA_LABEL,
  LOADING_FORM_MESSAGE,
} from '../../config/loadingUi.config';

/**
 * In-app `/login` route required by @hsus-dev/session-policy absolute-timeout navigation.
 * FEP does not host a login screen; redirect to the configured host portal (see VITE_HOST_PORTAL_URL).
 */
export const HostPortalLoginRedirect: React.FC = () => {
  useEffect(() => {
    window.location.replace(getHostPortalLoginUrl());
  }, []);

  return <LoadingSpinner message={LOADING_FORM_MESSAGE} ariaLabel={LOADING_FORM_ARIA_LABEL} />;
};
